var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bid",class:( _obj = {}, _obj[_vm.getType] = true, _obj[_vm.getBackgroundColour] = true, _obj )},[_c('div',{staticClass:"value"},[_vm._v(" "+_vm._s(_vm.getValue)+" ")]),(_vm.getShowSuitSymbol)?_c('suit-symbol',{attrs:{"suitName":_vm.getSuit,"withoutPadding":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }